import React, { ReactNode } from 'react';
import styled from 'styled-components';
import { ContainerInnerWithColumns } from '../../../shared/common/ContainerInner';
import { LoadingWrapper } from '../../../shared/components/LoadingWrapper';
import LoadingOverlay from '../../../shared/components/LoadingOverlay';
import DocumentTitle from '../../../shared/components/DocumentTitle';

const StContainer = styled.div<{ isLoading?: boolean }>`
    display: flex;
    align-items: flex-start;
    min-height: ${props => (props.isLoading ? '100vh' : '')};
`;
const StContentContainer = styled.div<{ isLoading?: boolean }>`
    padding-bottom: 80px;
    width: 100%;
    min-height: ${props => (props.isLoading ? '100vh' : '')};
`;

interface Props {
    loading?: boolean;
    documentTitle: string;
    topComponent?: ReactNode;
    sidebarComponent?: ReactNode;
    contentComponent: ReactNode;
    modalComponent?: ReactNode;
}

const ContentBaseLayout = (props: Props) => {
    const loading = props.loading;
    const baseTop = props.topComponent;
    const sidebar = props.sidebarComponent;
    const modal = props.modalComponent;

    return (
        <DocumentTitle title={props.documentTitle}>
            <ContainerInnerWithColumns isLoading={loading}>
                <LoadingWrapper>
                    <LoadingOverlay loading={loading} />
                </LoadingWrapper>
                {modal}
                {baseTop}
                <StContainer isLoading={loading}>
                    {sidebar}
                    <StContentContainer isLoading={loading}>{props.contentComponent}</StContentContainer>
                </StContainer>
            </ContainerInnerWithColumns>
        </DocumentTitle>
    );
};

export default ContentBaseLayout;
